// Product-event telemetry for the copilot: a small local ring buffer of
// significant things the user did, attached to the context envelope as
// behavioral signals ("you imported a list yesterday — sequence it?").
// Client-local by design for now; server-side aggregation can replace the
// storage later without changing emit call sites.

const STORAGE_KEY = "sg_copilot_events";
const MAX_EVENTS = 20;
const RECENT_LIMIT = 10;

// The event vocabulary. Emit ONLY these — the orchestrator prompt and the
// suggestion rules key off exact names.
export const COPILOT_EVENTS = {
  SEQUENCE_CREATED: "sequence_created",
  SEQUENCE_ACTIVATED: "sequence_activated",
  SEQUENCE_PAUSED: "sequence_paused",
  SEQUENCE_COMPLETED: "sequence_completed",
  CONTACTS_IMPORTED: "contacts_imported",
  CONTACTS_ADDED_TO_SEQUENCE: "contacts_added_to_sequence",
  LIST_CREATED: "list_created",
  BOUNCE_DETECTED: "bounce_detected",
  REPLY_RECEIVED: "reply_received",
  MEETING_BOOKED: "meeting_booked",
  INBOX_CONNECTED: "inbox_connected",
  INBOX_DISCONNECTED: "inbox_disconnected",
  LINKEDIN_DISCONNECTED: "linkedin_disconnected",
  CALL_LOGGED: "call_logged",
  CSV_EXPORTED: "csv_exported"
};

const read = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

// Dedupe window: some call sites fire from render paths (error-row mappers),
// so the same signal can repeat rapidly — one entry per type per window.
const DEDUPE_MS = 10 * 60 * 1000;

export const recordProductEvent = (type, data = {}) => {
  if (!Object.values(COPILOT_EVENTS).includes(type)) return;
  try {
    const events = read();
    const last = [...events].reverse().find(e => e.type === type);
    if (last && Date.now() - last.ts < DEDUPE_MS) return;
    events.push({ type, ts: Date.now(), ...data });
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(events.slice(-MAX_EVENTS))
    );
  } catch (e) {
    /* storage full/blocked — signals are best-effort */
  }
};

export const getRecentProductEvents = () => read().slice(-RECENT_LIMIT);
